// C:\Projects\texe-web\src\components\ImageModal.tsx
import { useEffect } from "react";
import { createPortal } from "react-dom";

type Props = {
  open: boolean;
  src?: string | null;
  alt?: string;
  onClose: () => void;
  /** Opsiyonel: görüntü başlığı */
  caption?: string;
};

export default function ImageModal({ open, src, alt, caption, onClose }: Props) {
  // ESC ile kapat + body scroll kilidi
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  const url = src ?? "";
  if (!url) return null;

  function stop(e: React.MouseEvent) {
    e.stopPropagation();
  }

  // PORTAL: her zaman body altına çiz → parent overflow/transform etkilenmez
  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-label={alt || "image"}
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.65)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2147483647, // en üstte
        padding: 16,
        animation: "imgmodal-fade 120ms ease-out",
      }}
    >
      {/* Kapat butonu */}
      <button
        onClick={onClose}
        aria-label="Close"
        style={{
          position: "fixed",
          top: 12,
          right: 12,
          width: 36,
          height: 36,
          borderRadius: 999,
          border: "none",
          cursor: "pointer",
          background: "rgba(255,255,255,0.9)",
          boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
          fontSize: 20,
          lineHeight: "36px",
        }}
      >
        ×
      </button>

      <div
        onClick={stop}
        style={{
          maxWidth: "92vw",
          maxHeight: "92vh",
          display: "flex",
          flexDirection: "column",
          gap: 8,
          alignItems: "center",
        }}
      >
        <img
          src={url}
          alt={alt || "image"}
          style={{
            maxWidth: "92vw",
            maxHeight: caption ? "86vh" : "92vh",
            objectFit: "contain",
            borderRadius: 12,
            boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
            background: "#000",
            display: "block",
            transform: "scale(1)",
            animation: "imgmodal-zoom 120ms ease-out",
          }}
          draggable={false}
        />
        {caption ? (
          <div
            style={{
              color: "white",
              fontSize: 14,
              textAlign: "center",
              opacity: 0.9,
              maxWidth: "92vw",
            }}
          >
            {caption}
          </div>
        ) : null}
      </div>

      <style>{`
        @keyframes imgmodal-fade {
          from { opacity: 0; } to { opacity: 1; }
        }
        @keyframes imgmodal-zoom {
          from { transform: scale(0.98); opacity: 0.8; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>,
    document.body
  );
}
